import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoShareSocial, IoClose, IoCopy, IoCheckmark, IoLogoTwitter, IoLogoWhatsapp, IoLogoFacebook } from 'react-icons/io5';
import './ShareButton.css';

export default function ShareButton({ title, text, url }) {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareUrl = url || window.location.href;
  const shareText = text || `Découvre "${title}" sur Plumly ! 🪶`;

  const handleNativeShare = () => {
    setIsOpen(true);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareLinks = [
    {
      name: 'Twitter / X',
      icon: IoLogoTwitter,
      color: '#1DA1F2',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
    },
    {
      name: 'WhatsApp',
      icon: IoLogoWhatsapp,
      color: '#25D366',
      url: `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`,
    },
    {
      name: 'Facebook',
      icon: IoLogoFacebook,
      color: '#1877F2',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
    },
  ];

  return (
    <>
      <motion.button
        className="reader-action"
        onClick={handleNativeShare}
        whileTap={{ scale: 0.9 }}
        title="Partager"
      >
        <IoShareSocial />
      </motion.button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              className="share-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
            />
            <motion.div
              className="share-panel"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
            >
              <div className="share-header">
                <h3>Partager</h3>
                <button className="share-close" onClick={() => setIsOpen(false)}><IoClose /></button>
              </div>

              <div className="share-social-grid">
                {shareLinks.map(link => {
                  const Icon = link.icon;
                  return (
                    <motion.a
                      key={link.name}
                      className="share-social-btn"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileTap={{ scale: 0.95 }}
                      style={{ background: link.color }}
                    >
                      <Icon />
                      <span>{link.name}</span>
                    </motion.a>
                  );
                })}
              </div>

              {navigator.share && (
                <motion.button
                  className="share-native-btn"
                  onClick={async () => {
                    try { await navigator.share({ title, text: shareText, url: shareUrl }); } catch (e) {}
                  }}
                  whileTap={{ scale: 0.95 }}
                >
                  📱 Plus d'options de partage...
                </motion.button>
              )}
              
              <div className="share-qr">
                <img
                  src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(shareUrl)}`}
                  alt="QR Code"
                  className="share-qr-img"
                />
                <p className="share-qr-label">Scanne pour ouvrir</p>
              </div>

              <div className="share-copy-row">
                <input className="share-url-input" value={shareUrl} readOnly />
                <motion.button
                  className="share-copy-btn"
                  onClick={handleCopy}
                  whileTap={{ scale: 0.9 }}
                >
                  {copied ? <IoCheckmark /> : <IoCopy />}
                </motion.button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}